import { render } from "./OrderedList.vue?vue&type=template&id=fd68799c&scoped=true"
import script from "./OrderedList.vue?vue&type=script&lang=js"
export * from "./OrderedList.vue?vue&type=script&lang=js"

import "./OrderedList.vue?vue&type=style&index=0&id=fd68799c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd68799c"]])

export default __exports__